import React from 'react';
import { Modal, Paper, Grid, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import './ModalWrapper.scss';

interface TOAModalProps {
	open: boolean;
	height?: 'tall' | 'normal';
	children: React.ReactNode;
	allowClickOutsideToClose?: boolean;
	hideBackdrop?: boolean;
	onCloseClicked?: () => void;
	constraintsRef?: React.MutableRefObject<null>;
	overflowInitial?: boolean;
}

const useStyles = makeStyles({
	root: {
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
});

const ModalWrapper: React.FC<TOAModalProps> = (props: TOAModalProps) => {
	const classes = useStyles();
	const { open, height, hideBackdrop, allowClickOutsideToClose, onCloseClicked, constraintsRef, overflowInitial } = props;

	const modalWrapperProps = {
		open: open,
		hideBackdrop: hideBackdrop,
		...(allowClickOutsideToClose && { onClose: onCloseClicked }),
	};

	return (
		<Modal {...modalWrapperProps} className='modal'>
			<Paper
				elevation={2}
				className={`${height === 'normal' ? 'modal-wrapper' : 'modal-wrapper wrapper--tall'} ${overflowInitial ? 'overflow-initial' : ''}`}
			>
				<Grid container direction='column' className='modal-wrapper-grid' ref={constraintsRef}>
					<Grid container item justify='flex-end' alignContent='flex-end' className='modal-wrapper-close-bar'>
						{onCloseClicked && (
							<IconButton
								aria-label='delete'
								onClick={onCloseClicked}
								disableRipple={true}
								disableTouchRipple={true}
								classes={{ root: classes.root }}
							>
								<CloseIcon />
							</IconButton>
						)}
					</Grid>
					<Grid container item className={`${height === 'normal' ? 'modal-wrapper-form-container' : 'modal-wrapper-form-container--tall'}`}>
						{props.children}
					</Grid>
				</Grid>
			</Paper>
		</Modal>
	);
};

ModalWrapper.defaultProps = {
	height: 'normal',
};

export default ModalWrapper;
